import PropTypes from 'prop-types'
import React from 'react'
import { withTheme } from 'styled-components'

import EarthMarker from '../EarthMarker'

import earthVideo from './assets/earth.mp4'
import earthLast from './assets/earth_last.png'
import { EarthImg } from './styles'

const EarthMedia = ({ loadContent, theme }) => {
  // states
  const [isEnded, setEnded] = React.useState(false)
  const [isLastFrameLoaded, setLastFrameLoaded] = React.useState(false)
  const [isVideoHidden, setHideVideo] = React.useState(false)

  // refs to components
  const videoRef = React.useRef()
  const lastImgRef = React.useRef()

  // control visibility of video and images
  React.useEffect(() => {
    const video = videoRef.current
    const onVideoEnded = () => {
      setEnded(true)
    }

    video?.addEventListener('ended', onVideoEnded)

    return () => {
      video?.removeEventListener('ended', onVideoEnded)
    }
  }, [loadContent])

  // handle load last frame
  React.useEffect(() => {
    const lastImg = lastImgRef.current
    const onLastFrameLoaded = () => {
      setLastFrameLoaded(true)
    }

    lastImg?.addEventListener('load', onLastFrameLoaded)
    if (lastImg && !lastImg.src) {
      lastImg.src = earthLast
    }

    return () => {
      lastImg?.removeEventListener('load', onLastFrameLoaded)
    }
  }, [loadContent, isEnded])

  // show last frame and hide video logic
  React.useEffect(() => {
    const lastImg = lastImgRef.current
    const imgFoundInHandler = () => setHideVideo(true)

    if (isEnded && isLastFrameLoaded) {
      lastImg?.style.setProperty('opacity', 1)
      lastImg?.addEventListener('transitionend', imgFoundInHandler)

      return () => {
        lastImg?.removeEventListener('transitionend', imgFoundInHandler)
      }
    }
  }, [isLastFrameLoaded, isEnded])

  // render
  return (
    <>
      {loadContent && !isVideoHidden && (
        <video
          ref={videoRef}
          style={{ width: '100%', height: '100%' }}
          autoPlay={true}
          playsInline={true}
          muted={true}
          loop={false}
        >
          <source src={earthVideo} type="video/mp4" />
        </video>
      )}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 800 450"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', left: 0, top: 0 }}
      >
        <defs>
          <mask id="earth-ancestry-mask" x="0" y="0" width="100%" height="100%">
            <rect x="0" y="0" width="100%" height="100%" fill="#fff" />
            <circle cx="400" cy="400" r="371" />
          </mask>
        </defs>
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill={theme.colors.grass}
          style={{ mask: 'url(#earth-ancestry-mask)' }}
        />
      </svg>

      {loadContent && <EarthImg ref={lastImgRef} alt="earth-frame" />}

      <EarthMarker isVisible={isEnded} />
    </>
  )
}

EarthMedia.propTypes = {
  loadContent: PropTypes.bool.isRequired,
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      grass: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default React.memo(withTheme(EarthMedia))
